import _defineProperty from "/builds/trovacantieri/trovacantieri-frontend/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.string.anchor.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import Vue from 'vue';
import AnchorMixin from "../../mixins/anchor.js";
import TimeoutMixin from "../../mixins/timeout.js";
import ModelToggleMixin from "../../mixins/model-toggle.js";
import PortalMixin from "../../mixins/portal.js";
import TransitionMixin from "../../mixins/transition.js";
import { getScrollTarget } from "../../utils/scroll.js";
import { addEvt, cleanEvt } from "../../utils/event.js";
import { clearSelection } from "../../utils/private/selection.js";
import { slot } from "../../utils/private/slot.js";
import { validatePosition, validateOffset, setPosition, parsePosition } from "../../utils/private/position-engine.js";
var attrs = {
  role: 'tooltip'
};
export default Vue.extend({
  name: 'QTooltip',
  mixins: [AnchorMixin, TimeoutMixin, ModelToggleMixin, PortalMixin, TransitionMixin],
  props: {
    maxHeight: {
      type: String,
      default: null
    },
    maxWidth: {
      type: String,
      default: null
    },
    transitionShow: {
      default: 'jump-down'
    },
    transitionHide: {
      default: 'jump-up'
    },
    anchor: {
      type: String,
      default: 'bottom middle',
      validator: validatePosition
    },
    self: {
      type: String,
      default: 'top middle',
      validator: validatePosition
    },
    offset: {
      type: Array,
      default: function _default() {
        return [14, 14];
      },
      validator: validateOffset
    },
    scrollTarget: {
      default: void 0
    },
    delay: {
      type: Number,
      default: 0
    },
    hideDelay: {
      type: Number,
      default: 0
    }
  },
  computed: {
    anchorOrigin: function anchorOrigin() {
      return parsePosition(this.anchor, this.$q.lang.rtl);
    },
    selfOrigin: function selfOrigin() {
      return parsePosition(this.self, this.$q.lang.rtl);
    },
    hideOnRouteChange: function hideOnRouteChange() {
      return this.persistent !== true;
    }
  },
  methods: {
    __show: function __show(evt) {
      var _this = this;
      this.__showPortal();
      this.__registerTick(function () {
        _this.observer = new MutationObserver(function () {
          return _this.updatePosition();
        });
        _this.observer.observe(_this.__portal.$el, {
          attributes: false,
          childList: true,
          characterData: true,
          subtree: true
        });
        _this.updatePosition();
        _this.__configureScrollTarget();
      });
      if (this.unwatch === void 0) {
        this.unwatch = this.$watch(function () {
          return _this.$q.screen.width + '|' + _this.$q.screen.height + '|' + _this.self + '|' + _this.anchor + '|' + _this.$q.lang.rtl;
        }, this.updatePosition);
      }

      // should __removeTimeout() if this gets removed
      this.__registerTimeout(function () {
        _this.__showPortal(true);
        _this.$emit('show', evt);
      }, 300);
    },
    __hide: function __hide(evt) {
      var _this2 = this;
      this.__removeTick();
      this.__anchorCleanup();
      this.__hidePortal();

      // should __removeTimeout() if this gets removed
      this.__registerTimeout(function () {
        _this2.__hidePortal(true); // done hiding, now destroy
        _this2.$emit('hide', evt);
      }, 300);
    },
    __anchorCleanup: function __anchorCleanup() {
      if (this.observer !== void 0) {
        this.observer.disconnect();
        this.observer = void 0;
      }
      if (this.unwatch !== void 0) {
        this.unwatch();
        this.unwatch = void 0;
      }
      this.__unconfigureScrollTarget();
      cleanEvt(this, 'tooltipTemp');
    },
    updatePosition: function updatePosition() {
      if (this.anchorEl === void 0 || this.__portal === void 0) {
        return;
      }
      var el = this.__portal.$el;
      if (el.nodeType === 8) {
        // IE replaces the comment with delay
        setTimeout(this.updatePosition, 25);
        return;
      }
      setPosition({
        el: el,
        offset: this.offset,
        anchorEl: this.anchorEl,
        anchorOrigin: this.anchorOrigin,
        selfOrigin: this.selfOrigin,
        maxHeight: this.maxHeight,
        maxWidth: this.maxWidth
      });
    },
    __delayShow: function __delayShow(evt) {
      var _this3 = this;
      if (this.$q.platform.is.mobile === true) {
        clearSelection();
        document.body.classList.add('non-selectable');
        var target = this.anchorEl;
        var evts = ['touchmove', 'touchcancel', 'touchend', 'click'].map(function (e) {
          return [target, e, '__delayHide', 'passiveCapture'];
        });
        addEvt(this, 'tooltipTemp', evts);
      }
      this.__registerTimeout(function () {
        _this3.show(evt);
      }, this.delay);
    },
    __delayHide: function __delayHide(evt) {
      var _this4 = this;
      if (this.$q.platform.is.mobile === true) {
        cleanEvt(this, 'tooltipTemp');
        clearSelection();
        // delay needed otherwise selection still occurs
        setTimeout(function () {
          document.body.classList.remove('non-selectable');
        }, 10);
      }

      // should __removeTimeout() if this gets removed
      this.__registerTimeout(function () {
        _this4.hide(evt);
      }, this.hideDelay);
    },
    __configureAnchorEl: function __configureAnchorEl() {
      if (this.noParentEvent === true || this.anchorEl === void 0) {
        return;
      }
      var evts = this.$q.platform.is.mobile === true ? [[this.anchorEl, 'touchstart', '__delayShow', 'passive']] : [[this.anchorEl, 'mouseenter', '__delayShow', 'passive'], [this.anchorEl, 'mouseleave', '__delayHide', 'passive']];
      addEvt(this, 'anchor', evts);
    },
    __unconfigureScrollTarget: function __unconfigureScrollTarget() {
      if (this.__scrollTarget !== void 0) {
        this.__changeScrollEvent(this.__scrollTarget);
        this.__scrollTarget = void 0;
      }
    },
    __configureScrollTarget: function __configureScrollTarget() {
      if (this.anchorEl !== void 0 || this.scrollTarget !== void 0) {
        this.__scrollTarget = getScrollTarget(this.anchorEl, this.scrollTarget);
        var fn = this.noParentEvent === true ? this.updatePosition : this.hide;
        this.__changeScrollEvent(this.__scrollTarget, fn);
      }
    },
    __renderPortal: function __renderPortal(h) {
      return h('transition', {
        props: _objectSpread({}, this.transitionProps)
      }, [this.showing === true ? h('div', {
        staticClass: 'q-tooltip q-tooltip--style q-position-engine no-pointer-events',
        class: this.contentClass,
        style: this.contentStyle,
        attrs: attrs
      }, slot(this, 'default')) : null]);
    }
  },
  created: function created() {
    this.__useTick('__registerTick', '__removeTick');
    this.__useTimeout('__registerTimeout');
  },
  mounted: function mounted() {
    this.__processModelChange(this.value);
  }
});